@if (sidebarElement(); as sidebarElement) {
  @if (sidebarElement.guidelineAction || sidebarElement.elementType === flowchartElementType.FlowchartSubflow) {
    <div class="sidebar-content" [class.no-header]="showAllMedications">
      <mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
        @if (showAllMedications) {
          <mat-tab>
            <div class="sidebar-content--medications-tab">
              <button aria-label="Back to component" size="small" ttButton variant="transparent" (click)="toggleShowAllMedications(false)">
                <mat-icon [icon]="'chevron-left'" [iconSize]="16" />
                {{ 'Sidebar.BackToComponent' | transloco }}
              </button>

              <sidebar-medications
                [guidelineComponent]="sidebarElement.guidelineAction"
                [isMedicationTab]="true"
                (medicationsChanged)="onMedicationsChanged($event)" />
            </div>
          </mat-tab>
        } @else {
          <mat-tab label="{{ 'Details' | transloco }}">
            <div class="sidebar-content--detail-tab">
              <sidebar-title-description
                [description]="sidebarElement.guidelineAction?.description"
                [onReset]="resetMedicalComponent"
                [showCheckbox]="sidebarElement.elementType !== flowchartElementType.FlowchartContainer"
                [showDescription]="sidebarElement.showDescription"
                [title]="sidebarElement.guidelineAction?.title"
                (descriptionChange)="onDescriptionChanged($event)"
                (showDescriptionChange)="onShowDescriptionChange($event)"
                (titleChange)="onTitleChanged($event)" />
              @if (sidebarElement.elementType === flowchartElementType.FlowchartContainer) {
                <div class="sidebar-content--detail-tab__container-content">
                  <tt-divider class="tt-guideline-sidebar_divider" />
                  <sidebar-selection-behavior
                    [guidelineComponent]="sidebarElement.guidelineAction"
                    [sidebarElement]="sidebarElement"
                    (selectionBehaviourChanged)="onSelectionBehaviourChanged($event)" />
                </div>
              }
              <tt-divider class="tt-guideline-sidebar_divider" />
              <sidebar-significance-preference
                [component]="sidebarElement"
                [preferredOptionOrder]="sidebarElement.guidelineAction?.preferredOptionOrder"
                [significance]="sidebarElement.guidelineAction?.significance"
                (significancePreferenceChanged)="onSignificancePreferenceChanged($event)" />
              <tt-divider class="tt-guideline-sidebar_divider" />
              <sidebar-recurrence
                [recurrence]="sidebarElement.guidelineAction?.recurrence"
                [recurrenceInterval]="sidebarElement.guidelineAction?.recurrenceInterval"
                (recurrenceChanged)="onRecurrenceChanged($event)"
                (recurrenceIntervalChanged)="onRecurrenceIntervalChanged($event)" />
              @if (sidebarElement.guidelineAction?.medicationRequests?.length > 0) {
                <tt-divider class="tt-guideline-sidebar_divider" />
                <sidebar-medications
                  [guidelineComponent]="sidebarElement.guidelineAction"
                  [isMedicationTab]="false"
                  (medicationsChanged)="onMedicationsChanged($event)"
                  (showAllMedicationsToggle)="toggleShowAllMedications($event)" />
              }

              <tt-divider class="tt-guideline-sidebar_divider" />

              <tt-guideline-component-sidebar-basics
                [attachments]="sidebarElement.attachments"
                [links]="sidebarElement.links"
                [references]="sidebarElement.references"
                [resourceTags]="sidebarElement.resourceTags"
                (basicsChanged)="handleBasicsChanged($event)" />

              <tt-divider class="tt-guideline-sidebar_divider" />

              @if (hasColorPresets()) {
                <div class="tt-guideline-sidebar_color-preset">
                  <span>{{ 'Color' | transloco }}:</span>
                  <tt-customisable-flowchart-element
                    [colorPresets]="colorPresets()"
                    [flowchartNodeConfig]="flowchartNodeConfig()"
                    (colorPresetChanged)="onColorPresetChanged($event)" />
                </div>

                <tt-divider class="tt-guideline-sidebar_divider" />
              }

              <div class="sidebar-content--detail-tab__container-content">
                @if (
                  (sidebarElement.elementType === flowchartElementType.FlowchartContainer &&
                    !sidebarElement.guidelineAction?.activityDefinition) ||
                  (sidebarElement.elementType === flowchartElementType.FlowchartSubflow &&
                    !sidebarElement.guidelineAction?.activityDefinition)
                ) {
                  <button
                    class="sidebar-content--detail-tab__container-content__add"
                    emphasis="minimal"
                    ttButton
                    variant="primary"
                    (click)="openSearchDialog()">
                    <mat-icon [icon]="'plus'" [iconSize]="14" />
                    <span>{{ 'SetMedicalComponent' | transloco }}</span>
                  </button>
                }
                @if (
                  sidebarElement.elementType === flowchartElementType.FlowchartSubflow && sidebarElement.guidelineAction?.activityDefinition
                ) {
                  <button
                    class="sidebar-content--detail-tab__container-content__add"
                    emphasis="minimal"
                    ttButton
                    variant="primary"
                    (click)="removeAction()">
                    <mat-icon [icon]="'x'" [iconSize]="12" />
                    <span>{{ 'ResetMedicalComponent' | transloco }}</span>
                  </button>
                }
              </div>
            </div>
          </mat-tab>
        }
        @if (!showAllMedications && !sidebarElement.guidelineAction?.proposedComponent) {
          <mat-tab label="{{ 'TechnicalInfo' | transloco }}">
            @if (sidebarElement?.guidelineAction?.activityDefinition) {
              <sidebar-technical-info
                [guidelineComponent]="sidebarElement.guidelineAction?.activityDefinition"
                [label]="'ActivityDefinition' | transloco" />
            }
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  }
}
